import { constructAssemblyPayload } from './videoUtils'

const TIMELINE_EDITOR_URL = 'https://video-editor.sharelookapp.com/'

const parseJSONSafely = (value, fallback) => {
  if (value === null || value === undefined || value === 'null') {
    return fallback
  }

  let result = value
  let depth = 0

  while (typeof result === 'string' && depth < 5) {
    try {
      result = JSON.parse(result)
      depth++
    } catch (error) {
      return fallback
    }
  }

  return result
}

export const getTimelineProjectId = video =>
  video?.timeline_project_id ||
  video?.timelineProjectId ||
  video?.data?.timeline_project_id ||
  video?.data?.timelineProjectId ||
  null

export const getTimelineEditorUrl = projectId =>
  projectId
    ? `${TIMELINE_EDITOR_URL}?project=${encodeURIComponent(projectId)}`
    : null

export const withTimelineEditorRedirect = (editorUrl, redirectUrl) => {
  if (!editorUrl) return null
  if (!redirectUrl) return editorUrl

  try {
    const url = new URL(editorUrl, TIMELINE_EDITOR_URL)
    url.searchParams.set('back', redirectUrl)
    return url.toString()
  } catch (error) {
    const separator = editorUrl.includes('?') ? '&' : '?'
    return `${editorUrl}${separator}back=${encodeURIComponent(redirectUrl)}`
  }
}

export const getTimelineVideoHistory = history => {
  const parsedHistory = parseJSONSafely(history, [])
  return Array.isArray(parsedHistory) ? parsedHistory : []
}

export const createTimelineExportHistoryEntry = timelineExport => ({
  date: timelineExport?.created_at || new Date().toISOString(),
  url: timelineExport?.url,
  hasMusic: false,
  source: 'timeline_editor',
  timelineExportVersion: timelineExport?.version,
  timelineExportFormat: timelineExport?.format || null,
  timelineExportRange: timelineExport?.range || null,
  duration_at_generation: Number.isFinite(Number(timelineExport?.duration))
    ? Number(timelineExport.duration)
    : null
})

export const getTimelineShotList = video => {
  const shotListCandidates = [
    video?.shot_list,
    video?.shotList,
    video?.data?.shot_list,
    video?.data?.shotList
  ]
  const scenes =
    shotListCandidates
      .map(candidate => parseJSONSafely(candidate, []))
      .find(candidate => Array.isArray(candidate) && candidate.length > 0) || []

  return scenes.map(scene => ({
    ...scene,
    shots: Array.isArray(scene?.shots)
      ? scene.shots.map(shot => ({
          ...shot,
          vidSrc:
            shot?.vidSrc ||
            shot?.vid_src ||
            shot?.video_url ||
            shot?.videoUrl ||
            null
        }))
      : []
  }))
}

export const hasCompleteTimelineShots = video => {
  const scenes = getTimelineShotList(video)

  return (
    Array.isArray(scenes) &&
    scenes.length > 0 &&
    scenes.every(
      scene =>
        Array.isArray(scene?.shots) &&
        scene.shots.length > 0 &&
        scene.shots.every(shot => Boolean(shot?.vidSrc))
    )
  )
}

export const buildTimelineEditorPayload = video => {
  const payload = constructAssemblyPayload(
    getTimelineShotList(video),
    parseJSONSafely(video?.location_map || video?.locationMap, {}),
    true,
    parseJSONSafely(video?.transitions, {})
  )
  const videoId = video?.id || video?.video_id

  if (videoId) {
    payload.video_id = videoId
  }

  return payload
}
